import React from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import Form from 'muicss/lib/react/form'
import { TextField } from 'redux-form-material-ui'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { contact } from '../../../actions'


class ReportDialog extends React.Component {

  handleClose = () => {
    this.props.toggleOpen()
  }

  handleSubmit = (values) => {
    this.props.toggleOpen()
    this.props.contact(values)
    this.props.showSnackbar()
  }


  render() {
    const actions = [
      <FlatButton
        label="Cancelar"
        primary
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Enviar"
        primary
        type="submit"
        form="reportDialogForm"
      />,
    ]

    return (
      <Dialog
        title="Contáctanos"
        modal={false}
        actions={actions}
        open={this.props.open}
        onRequestClose={this.handleClose}
      >
        <Form id="reportDialogForm" onSubmit={this.props.handleSubmit(this.handleSubmit)}>
          <Field
            name="comments"
            component={TextField}
            floatingLabelText="Ingresa tus comentarios aquí"
            fullWidth
            multiLine
            rows={4}
            rowsMax={8}
          />
          <Field
            name="type"
            style={{ display: 'none' }}
            component={TextField}
          />
        </Form>
      </Dialog>
    )
  }

}

ReportDialog.propTypes = {
  open: React.PropTypes.bool.isRequired,
  toggleOpen: React.PropTypes.func.isRequired,
  handleSubmit: React.PropTypes.func.isRequired,
  contact: React.PropTypes.func.isRequired,
  showSnackbar: React.PropTypes.func.isRequired,
}

const mapStateToProps = state => ({ ...state.user,
  initialValues: {
    type: 0,
  } })

const mapDispatchToProps = dispatch => ({
  contact: values => dispatch(contact(values)),
})

const ReduxReportDialog = reduxForm({
  form: 'ReportForm',
})(ReportDialog)


export default connect(mapStateToProps, mapDispatchToProps)(ReduxReportDialog)



// WEBPACK FOOTER //
// ./src/components/Contact/ReportDialog/index.jsx